import React from "react";

export const MainText = () => {
  return (
    <>
      <div className="irq-top-text border-bottom">
        Here are today's loan options based on your information
      </div>
      <div className="irq-top-text-subtitle">
        Choose up to five loans you'd like to compare below. Need more
        information? Click "View Details" for an in-depth breakdown of the cost
        of the loan. Click the edit icons if you need to adjust your
        information.
      </div>
    </>
  );
};
